import { JssScript } from './smart-jss';
import { SmartPlugin } from '../smart';
import { BreakpointPlugin } from './smart-breakpoints';

export class SmartGridBreakpints extends BreakpointPlugin{
    constructor(props){
        super('smart-grid-breakpoints', props);
    }

    extendJss(bp) {
        bp = bp.name;
        var gridPlugin = this.$options.smart.$plugins['smart-grids'];

        var sizes = gridPlugin.$options.sizes;
        var columns = gridPlugin.$options.columns || Math.max(...sizes);

        const displayNone = { 'display': 'none' }
        var gridJss = { [`& > .${bp}-col-span-0`]: displayNone, [`& > .${bp}-fill`]: { 'grid-column-end': -1} }
        var aboveGridJss = { [`& > .above-${bp}-col-span-0`]: displayNone, [`& > .above-${bp}-fill`]: { 'grid-column-end': -1 } }
        var belowGridJss = { [`& > .below-${bp}-col-span-0`]: displayNone, [`& > .below-${bp}-fill`]: { 'grid-column-end': -1 } }

        for (var i = 0; i < columns; i++) {
            gridJss[`& > .${bp}-col-span-${i + 1}`] = {
                'grid-column-end': 'span ' + i
            }
            aboveGridJss[`& > .above-${bp}-col-span-${i + 1}`] = {
                'grid-column-end': 'span ' + i
            }
            belowGridJss[`& > .below-${bp}-col-span-${i + 1}`] = {
                'grid-column-end': 'span ' + i
            }

            for (var j = 1; j <= columns; j++) {
                gridJss[`& > .${bp}-col-${j-1}`] = {
                    'grid-column-start': j
                }
                aboveGridJss[`& > .above-${bp}-col-${j-1}`] = {
                    'grid-column-start': j
                }
                belowGridJss[`& > .below-${bp}-col-${j-1}`] = {
                    'grid-column-start': j
                }

                gridJss[`& > .${bp}-col-span-${j}`] = {
                    'grid-column-end': 'span ' + j
                }
                aboveGridJss[`& > .above-${bp}-col-span-${j}`] = {
                    'grid-column-end': 'span ' + j
                }
                belowGridJss[`& > .below-${bp}-col-span-${j}`] = {
                    'grid-column-end': 'span ' + j
                }
            }
        }

        return {
            exact: { grid: gridJss },
            above: { grid: aboveGridJss },
            below: { grid: belowGridJss },
        }
    }
}

export class SmartGrids extends SmartPlugin{
    constructor(props){
        super('smart-grids', {...props, sizes:{default:[12, 24]}});
    }

    initialize(props){
        super.initialize(props);

        var sizes = this.$options.sizes;
        var columns = this.$options.columns || Math.max(...sizes);
        var rows = this.$options.rows || 0;


        var baseJss = {
            display: 'grid',
            '& > .fill': { 'grid-column-end': -1 },
            '& > .col-span-0': { display: 'none' }
        };
        for (var i = 1; i <= columns; i++) {
            baseJss[`& > .col-${i-1}`] = {
                'grid-column-start': i
            }
            baseJss[`& > .col-span-${i}`] = {
                'grid-column-end': `span ${i}`
            }
        }

        for (i = 1; i <= rows; i++) {
            baseJss[`& > .row-${i-1}`] = {
                'grid-row-start': i
            }
            baseJss[`& > .row-span-${i}`] = {
                'grid-row-end': `span ${i}`
            }
        }

        sizes.forEach(size => {
            baseJss[`&.grid-${size}`] = {
                'grid-template-columns': `repeat(${size}, 1fr)`,
                
            }
        });

        var script = this.$jssScript || (this.$jssScript = new JssScript(this.$options.smart.$plugins['smart-jss'].$jss));
        script.$data = { grid: baseJss };
        script.rebuild();
    }
}